/**
 * Câu hỏi ngắn cho thẻ công cụ ở /cong-cu: mỗi công cụ trả lời một câu hỏi
 * founder hay bị nhà đầu tư hỏi. Ngắn hơn blurb để thẻ ít chữ; công cụ chưa có
 * câu ở đây thì thẻ dùng blurb.
 */
export const CAU_HOI_CONG_CU = {
  "diem-san-sang-goi-von": "Hồ sơ của mình đã sẵn sàng gặp nhà đầu tư chưa?",
  "tinh-runway": "Tiền còn đủ hoạt động bao nhiêu tháng?",
  "goi-bao-nhieu": "Nên gọi bao nhiêu, và tiêu vào việc gì?",
  "kiem-tra-gia-dinh-kinh-te-don-vi": "Giả định về giá, chi phí, giữ chân khách có hợp lý không?",
  "chi-so-tang-truong": "Doanh thu đang tăng nhanh và đều đến đâu?",
  "chia-co-phan-dong-sang-lap": "Chia cổ phần giữa các nhà sáng lập thế nào cho hợp lý?",
  "bang-co-phan-va-pha-loang": "Qua mỗi vòng, mỗi người còn giữ bao nhiêu phần trăm?",
  "mo-phong-vong-goi-von": "Định giá và số tiền gọi làm phần của mình thay đổi ra sao?",
  "safe-va-trai-phieu-chuyen-doi": "Đã ký SAFE, vậy thực sự đã bán bao nhiêu phần trăm?",
  "dinh-gia-pre-seed": "Chưa có doanh thu thì định giá khoảng bao nhiêu?",
  "dinh-gia-co-doanh-thu": "Đã có doanh thu thì định giá khoảng bao nhiêu?",
  "ho-so-phap-ly-khoi-nghiep": "Hồ sơ pháp lý còn thiếu gì, làm cái nào trước?",
  "pitch-deck-10-slide": "Deck 10 slide đã đủ ý cho vòng đầu chưa?",
  "quy-mo-thi-truong": "Thị trường của mình thực sự lớn bao nhiêu?",
  "quy-phu-hop": "Quỹ nào đang đầu tư đúng ngành, đúng giai đoạn của mình?",
  "doc-term-sheet": "Bán công ty ở mức này thì mình thực nhận bao nhiêu?",
};
